"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionStorage = void 0;
const __1 = require("../..");
class TransactionStorage {
    constructor(arcxLogger, pendingTransactionsCollection) {
        this.arcxLogger = arcxLogger;
        this.pendingTransactionsCollection = pendingTransactionsCollection;
    }
    createPendingTransactions(chainId, newPendingTransactions) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (newPendingTransactions.length === 0)
                    return;
                yield this.pendingTransactionsCollection[(0, __1.getNetworkGroup)(chainId)].insertMany(newPendingTransactions);
            }
            catch (error) {
                this.arcxLogger.error(`TransactionStorage::createPendingTransactions => ${error}`);
            }
        });
    }
    readPendingTransactions(chainId, account, protocol) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = Object.assign({ account }, (protocol && { score_name: protocol }));
            try {
                const pendingTransaction = (yield this.pendingTransactionsCollection[(0, __1.getNetworkGroup)(chainId)]
                    .find(query)
                    .toArray());
                return pendingTransaction;
            }
            catch (error) {
                this.arcxLogger.warning(`TransactionStorage::readPendingTransactions => Could not find pending transactios for ${account}: ${error}`);
                return [];
            }
        });
    }
    readPendingTransactionsFromTransactionIds(chainId, transactionIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const pendingTransactions = (yield this.pendingTransactionsCollection[(0, __1.getNetworkGroup)(chainId)]
                .find({ transaction_id: { $in: transactionIds } })
                .toArray());
            return pendingTransactions;
        });
    }
    deletePendingTransactions(chainId, transactionIds) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.pendingTransactionsCollection[(0, __1.getNetworkGroup)(chainId)].deleteMany({
                    transaction_id: { $in: transactionIds },
                });
            }
            catch (error) {
                this.arcxLogger.warning(`TransactionStorage::deletePendingTransactions => Could not delete pending transactions: ${error}`);
            }
        });
    }
    updatePendingTransactions(chainId, newPendingTransactions) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (newPendingTransactions.length === 0)
                    return;
                yield this.pendingTransactionsCollection[(0, __1.getNetworkGroup)(chainId)].bulkWrite(newPendingTransactions.map((pendingTransaction) => {
                    delete pendingTransaction._id;
                    return {
                        updateOne: {
                            filter: {
                                method: pendingTransaction.method,
                                transaction_id: pendingTransaction.transaction_id,
                            },
                            update: { $set: pendingTransaction },
                        },
                    };
                }));
            }
            catch (error) {
                this.arcxLogger.error(`TransactionStorage::updatePendingTransactions => ${error}`);
            }
        });
    }
}
exports.TransactionStorage = TransactionStorage;
//# sourceMappingURL=TransactionStorage.js.map